import React from 'react';
import { FormikProps } from 'formik';
import { Modal, Tabs } from 'antd';

import { FinancialInfoFormValues } from '../FinancialInfo';
import useFinancialInfoTabs, {
  FinancialInfoOptions,
  MultiRatesTypeEnum,
} from 'hooks/useFinancialInfoTabs';
import { useAppSelector } from 'hooks/useAppSelector';
import { payRateTypesSelector } from 'redux/selectors/assignmentSelectors';

import styles from './FinancialRatesSectionArray.module.less';

type Props = FinancialInfoOptions;

export default function FinancialRatesSectionArray(props: Props) {
  const { form } = props;
  const { values } = form as FormikProps<FinancialInfoFormValues>;
  const payRateTypes = useAppSelector(payRateTypesSelector);
  const [tabs, handleAddTab, handleRemoveTab, activeTab, changeActiveTab] =
    useFinancialInfoTabs(props);

  const isScheduler = props?.mode === MultiRatesTypeEnum.Schedule;
  const isAddBtnHidden =
    isScheduler || payRateTypes.length === values.multiRates?.length;

  const handleFinancialInfoEdit = (
    targetKey: React.MouseEvent | React.KeyboardEvent | string,
    action: 'add' | 'remove',
  ) => {
    if (action === 'add') {
      handleAddTab();
    } else {
      Modal.confirm({
        title:
          'Please confirm the removal of Additional Rate. All data will be removed. Are you sure?',
        icon: <span className="icon icon-attention-filled" />,
        onOk() {
          handleRemoveTab(targetKey);
        },
        onCancel() {},
      });
    }
  };

  return (
    <div className={styles.tabs}>
      <Tabs
        type={isScheduler ? 'card' : 'editable-card'}
        items={tabs}
        onEdit={handleFinancialInfoEdit}
        activeKey={activeTab}
        onChange={changeActiveTab}
        destroyInactiveTabPane={true}
        hideAdd={isAddBtnHidden}
      />
    </div>
  );
}
